module.exports = "/_next/static/images/Frame-fce27ea86bb9f41bbef3542089a8901a.webp";